import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { EXEC_SUPPORT } from "@/data/content";

const IMG =
  "https://images.pexels.com/photos/8117437/pexels-photo-8117437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const ExecutiveSupport = () => {
  return (
    <section className="py-20 md:py-28 bg-[#0e7d72]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5 order-2 lg:order-1"
        >
          <div className="relative">
            <div className="absolute -inset-3 bg-[#ffc247] rounded-[2rem] rotate-2" />
            <img
              src={IMG}
              alt="Coordinación de proyectos y soporte ejecutivo"
              className="relative rounded-[2rem] w-full h-[420px] object-cover"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7 order-1 lg:order-2 text-white"
        >
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ffc247]">
            {EXEC_SUPPORT.overline}
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            {EXEC_SUPPORT.title}
          </h2>
          <p className="mt-5 text-lg text-white/80 leading-relaxed max-w-xl">
            {EXEC_SUPPORT.desc}
          </p>

          <ul className="mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {EXEC_SUPPORT.items.map((item, i) => (
              <li
                key={i}
                data-testid={`exec-item-${i}`}
                className="flex items-center gap-3 text-white"
              >
                <span className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-[#ffc247]" />
                </span>
                <span className="font-medium">{item}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
